import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {LoginComponent} from './login/login.component';
import {MapComponent} from './network/map/map.component';
import {PropertiesDictionaryComponent} from './users/properties-dictionary/properties-dictionary.component';
import {CustomersComponent} from './network/customers/customers.component';
import {AuthenticationGuard} from './guards/authentication/authentication.guard';
import {ResourceGroupsComponent} from './network/resource-groups/resource-groups.component';
import {NodesComponent} from './network/nodes/nodes.component';
import {ArmComponent} from './arm/arm.component';
import {IpProfilesComponent} from './network/ip-profiles/ip-profiles.component';
import {IpProfilesResolver} from './network/ip-profiles/ip-profiles-resolver';
import {PconsComponent} from './network/pcons/pcons.component';
import {VoipPeersComponent} from './network/voip-peers/voip-peers.component';
import {DeviceLocationComponent} from './users/device-location/device-location.component';
import {RegisteredUsersComponent} from './users/registered-users/registered-users.component';
import {ConnectionsComponent} from './network/connections/connections.component';
import {ServersComponent} from './users/servers/servers.component';
import {FileRepositoryComponent} from './users/file-repository/file-repository.component';
import {UserGroupsComponent} from './users/user-groups/user-groups.component';
import {UsersTabComponent} from './users/users-tab/users-tab.component';
import {ActiveAlarmsComponent} from './alarms/active-alarms/active-alarms.component';
import {HistoryAlarmsComponent} from './alarms/history-alarms/history-alarms.component';
import {JournalComponent} from './alarms/journal/journal.component';
import {SnmpDestinationComponent} from './alarms/snmp-destination/snmp-destination.component';
import {AlarmsAdvancedComponent} from './alarms/alarms-advanced/alarms-advanced.component';
import {GraphsComponent} from './statistics/graphs/graphs.component';
import {ThresholdsComponent} from './statistics/thresholds/thresholds.component';
import {ThresholdsResolver} from './statistics/thresholds/thresholds-resolver';
import {AdministrationGuard} from './guards/settings/administration/administration.guard';
import {AdministrationComponent} from './settings/administration/administration.component';
import {LicenseSettingsComponent} from './settings/administration/license-settings/license-settings.component';
import {CallsComponent} from './calls/calls-list/calls.component';
import {SecuritySettingsComponent} from './settings/administration/security-settings/security-settings.component';
import {RemoteManagerComponent} from './settings/administration/remote-manager/remote-manager.component';
import {AnalyticsSettingsComponent} from './settings/administration/analytics-settings/analytics-settings.component';
import {
  RadiusAuthenticationComponent
} from './settings/administration/radius-authentication/radius-authentication.component';
import {LdapAuthenticationComponent} from './settings/administration/ldap-authentication/ldap-authentication.component';
import {
  AzureAuthenticationComponent
} from './settings/administration/azure-authentication/azure-authentication.component';
import {
  TrustedCertificatesComponent
} from './settings/administration/trusted-certificates/trusted-certificates.component';
import {
  ConfiguratorCredentialsComponent
} from './settings/administration/configurator-credentials/configurator-credentials.component';
import {
  NodeCredentialsComponent
} from './settings/administration/credentials/node-credentials/node-credentials.component';
import {
  RouterCredentialsComponent
} from './settings/administration/credentials/router-credentials/router-credentials.component';
import {NetworkServicesComponent} from './settings/network-services/network-services.component';
import {SyslogComponent} from './settings/network-services/syslog/syslog.component';
import {NtpComponent} from './settings/network-services/ntp/ntp.component';
import {QosComponent} from './settings/network-services/qos/qos.component';
import {CdrComponent} from './settings/network-services/cdr/cdr.component';
import {OperatorsSettingsComponent} from './settings/administration/operators-settings/operators-settings.component';
import {
  ConfiguratorCertificateComponent
} from './settings/administration/configurator-certificate/configurator-certificate.component';
import {GroupsComponent} from './routing/groups/groups.component';
import {AdvancedComponent} from './settings/advanced/advanced.component';
import {AdvancedUsersComponent} from './settings/advanced/advanced-users/advanced-users.component';
import {CallFlowConfigurationsComponent} from './settings/call-flow-configurations/call-flow-configurations.component';
import {
  NormalizationBeforeRoutingComponent
} from './settings/call-flow-configurations/normalization-before-routing/normalization-before-routing.component';
import {AdvancedCallsComponent} from './settings/advanced/advanced-calls/advanced-calls.component';
import {RoutingServersComponent} from './settings/routing-servers/routing-servers.component';
import {RoutingServersSettingsComponent} from './settings/routing-servers/routing-servers-settings/routing-servers-settings.component';
import {RoutingServersGroupsSettingsComponent} from './settings/routing-servers/routing-servers-groups-settings/routing-servers-groups-settings.component';
import {WebServicesComponent} from './settings/call-flow-configurations/web-services/web-services.component';
import {
  NormalizationGroupsComponent
} from './settings/call-flow-configurations/normalization-groups/normalization-groups.component';
import {PrefixGroupsComponent} from './settings/call-flow-configurations/prefix-groups/prefix-groups.component';
import {RoutingComponent} from './settings/routing/routing.component';
import {QualityBasedRoutingComponent} from './settings/routing/quality-based-routing/quality-based-routing.component';
import {
  GlobalRoutingSettingsComponent
} from './settings/routing/global-routing-settings/global-routing-settings.component';
import {
  RegistrationRoutingSettingComponent
} from './settings/routing/registration-routing-setting/registration-routing-setting.component';
import {CacProfilesComponent} from './settings/routing/cac-profiles/cac-profiles.component';
import {CallsQuotaComponent} from './settings/routing/calls-quota/calls-quota.component';
import {RulesComponent} from './routing/rules/rules.component';
import {TimeBasedRoutingComponent} from './settings/routing/time-based-routing/time-based-routing.component'
import {ShortCallsProfilesComponent} from './settings/routing/short-calls-profiles/short-calls-profiles.component';

import {
  AlternativeRoutingSipReasonsComponent
} from './settings/routing/alternative-routing-sip-reasons/alternative-routing-sip-reasons.component';
import {PolicyStudioComponent} from './settings/call-flow-configurations/policy-studio/policy-studio.component';
import {AzureResolver} from './login/azure-resolver';
import {OfflineMapComponent} from './network/offline-map/offline-map.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import {DynamicBlacklistComponent} from './calls/dynamic-blacklist/dynamic-blacklist.component';
import {
  AdvancedStatisticsComponent
} from './settings/advanced/advanced-statistics/advanced-statistics.component';
import {SecurityPoliciesComponent} from './settings/administration/security-policies/security-policies.component';
import {SipConditionGroupsComponent} from './settings/call-flow-configurations/sip-condition-groups/sip-condition-groups.component';
import {SipManipulationGroupsComponent} from './settings/call-flow-configurations/sip-manipulation-groups/sip-manipulation-groups.component';
import {WebSocketComponent} from './settings/network-services/web-socket/web-socket.component';

const networkRoutes: Routes = [
  {path: 'map', component: MapComponent},
  {path: 'offline', component: OfflineMapComponent},
  {path: 'nodes', component: NodesComponent, data: {text: 'nodes'}},
  {path: 'pcons', component: PconsComponent, data: {text: 'peer connections'}},
  {path: 'voips', component: VoipPeersComponent, data: {text: 'voip peers'}},
  {path: 'connections', component: ConnectionsComponent},
  {path: 'resourceGroups', component: ResourceGroupsComponent, data: {text: 'resource groups'}},
  {path: 'ipProfiles', component: IpProfilesComponent, data: {text: 'ip profiles'}, resolve: {
      ipProfileDefinition: IpProfilesResolver}},
  {path: 'customers', component: CustomersComponent, data: {text: 'customers'}},
  {path: '**', pathMatch: 'full', redirectTo: '', data: {default: 'map'}}
];

const routingRoutes: Routes = [
  { path: 'groups', component: GroupsComponent, data: {text: 'routing groups'}},
  { path: 'rules', component: RulesComponent, data: {text: 'routing rules'}},
  {path: '**', pathMatch: 'full', redirectTo: '', data: {default: 'groups'}}
];

const usersRoutes: Routes = [
  {path: 'users', component: UsersTabComponent},
  {path: 'registeredUsers', component: RegisteredUsersComponent, data: {text: 'registered users'}},
  {path: 'usersGroups', component: UserGroupsComponent, data: {text: 'users groups'}},
  {path: 'servers', component: ServersComponent, data: {text: 'servers'}},
  {path: 'fileRepository', component: FileRepositoryComponent, data: {text: 'file repository'}},
  {path: 'propertyDictionary', component: PropertiesDictionaryComponent, data: {text: 'property dictionary'}},
  {path: 'deviceLocation', component: DeviceLocationComponent, data: {text: 'device location'}},
  {path: '**', pathMatch: 'full', data: {default: 'users'}, redirectTo: ''}
];

const alarmsRoutes: Routes = [
  {path: 'active', component: ActiveAlarmsComponent, data: {text: 'active alarms'}},
  {path: 'history', component: HistoryAlarmsComponent, data: {text: 'history alarms'}},
  {path: 'journal', component: JournalComponent},
  {path: 'snmp', component: SnmpDestinationComponent, data: {text: 'snmp destinations'}},
  {path: 'advanced', component: AlarmsAdvancedComponent},
  {path: '**', pathMatch: 'full', data: {default: 'active'}, redirectTo: ''}
];

const statisticsRoutes: Routes = [
  {path: 'graphs', component: GraphsComponent},
  {path: 'thresholds', component: ThresholdsComponent, resolve: {
      structure: ThresholdsResolver
    }},
  {path: '**', pathMatch: 'full', redirectTo: '', data: {default: 'graphs'}}
];

const callsRoutes: Routes = [
  {path: 'callsList', component: CallsComponent, data: {text: 'calls list'}},
  {path: 'dynamicBlacklist', component: DynamicBlacklistComponent, data: {text: 'dynamic blacklist'}},
  {path: '**', pathMatch: 'full', redirectTo: '', data: {default: 'callsList'}}
];

const administrationRoutes: Routes = [
  { path: 'security', component: SecuritySettingsComponent, data: {navAutoHidden: true}},
  { path: 'configuratorCertificate', component: ConfiguratorCertificateComponent, data: {navAutoHidden: true}},
  { path: 'license', component: LicenseSettingsComponent, data: {navAutoHidden: true}},
  { path: 'operators', component: OperatorsSettingsComponent, data: {navAutoHidden: true}},
  { path: 'securityPolicies', component: SecurityPoliciesComponent, data: {navAutoHidden: true}},
  { path: 'nodeCredentials', component: NodeCredentialsComponent, data: {navAutoHidden: true, type: 'DEVICE'}},
  { path: 'routerCredentials', component: RouterCredentialsComponent, data: {navAutoHidden: true, type: 'ROUTER'}},
  { path: 'configuratorCredentials', component: ConfiguratorCredentialsComponent, data: {navAutoHidden: true}},
  { path: 'ldapAuthentication', component: LdapAuthenticationComponent, data: {navAutoHidden: true}},
  { path: 'radiusAuthentication', component: RadiusAuthenticationComponent, data: {navAutoHidden: true}},
  { path: 'azureAuthentication', component: AzureAuthenticationComponent, data: {navAutoHidden: true}},
  { path: 'remoteManager', component: RemoteManagerComponent, data: {navAutoHidden: true}},
  { path: 'certificates', component: TrustedCertificatesComponent, data: {navAutoHidden: true}},
  { path: 'analytics', component: AnalyticsSettingsComponent, data: {navAutoHidden: true}},
  {path: '**', pathMatch: 'full', redirectTo: '', data: {default: 'license'}}
];

const networkServicesRoutes: Routes = [
  { path: 'syslog', component: SyslogComponent, data: {navAutoHidden: true}},
  { path: 'ntp', component: NtpComponent, data: {navAutoHidden: true}},
  { path: 'qos', component: QosComponent, data: {navAutoHidden: true}},
  { path: 'cdr', component: CdrComponent, data: {navAutoHidden: true}},
  { path: 'web-socket', component: WebSocketComponent, data: {navAutoHidden: true}},
  {path: '**', pathMatch: 'full', redirectTo: '', data: {default: 'syslog'}}
];

const callFlowConfigurationRoutes: Routes = [
  { path: 'normalizationGroups', component: NormalizationGroupsComponent, data: {navAutoHidden: true}},
  { path: 'normalizationBeforeRouting', component: NormalizationBeforeRoutingComponent, data: {navAutoHidden: true}},
  { path: 'prefixGroups', component: PrefixGroupsComponent, data: {navAutoHidden: true}},
  { path: 'policyStudio', component: PolicyStudioComponent, data: {navAutoHidden: true}},
  { path: 'webServices', component: WebServicesComponent, data: {navAutoHidden: true}},
  { path: 'sipConditionGroups', component: SipConditionGroupsComponent, data: {navAutoHidden: true}},
  { path: 'sipManipulationGroups', component: SipManipulationGroupsComponent, data: {navAutoHidden: true}},
  {path: '**', pathMatch: 'full', redirectTo: '', data: {default: 'normalizationGroups'}}
];

const routingConfigurationRoutes: Routes = [
  { path: 'qualityBasedRouting', component: QualityBasedRoutingComponent, data: {navAutoHidden: true}},
  { path: 'timeBasedRouting', component: TimeBasedRoutingComponent, data: {navAutoHidden: true}},
  { path: 'altRoutingSIPReasons', component: AlternativeRoutingSipReasonsComponent, data: {navAutoHidden: true}},
  { path: 'routingSettings', component: GlobalRoutingSettingsComponent, data: {navAutoHidden: true}},
  { path: 'registrationRoutingSettings', component: RegistrationRoutingSettingComponent, data: {navAutoHidden: true}},
  { path: 'callsQuotaSettings', component: CallsQuotaComponent, data: {navAutoHidden: true}},
  { path: 'cacProfiles', component: CacProfilesComponent, data: {navAutoHidden: true}},
  { path: 'shortCallsProfilesSettings', component: ShortCallsProfilesComponent, data: {navAutoHidden: true}},
  { path: '**', pathMatch: 'full', redirectTo: '', data: {default: 'qualityBasedRouting'}}
];

const routingServersRoutes: Routes = [
  { path: 'servers', component: RoutingServersSettingsComponent, data: {navAutoHidden: true}},
  { path: 'groups', component: RoutingServersGroupsSettingsComponent, data: {navAutoHidden: true}},
  {path: '**', pathMatch: 'full', redirectTo: '', data: {default: 'servers'}}
];

const advancedRoutes: Routes = [
  { path: 'calls', component: AdvancedCallsComponent, data: {navAutoHidden: true}},
  { path: 'users', component: AdvancedUsersComponent, data: {navAutoHidden: true}},
  { path: 'statistics', component: AdvancedStatisticsComponent, data: {navAutoHidden: true}},
  {path: '**', pathMatch: 'full', redirectTo: '', data: {default: 'calls'}}
];

const settingsRoutes: Routes = [
  {
    path: 'administration',
    component: AdministrationComponent,
    children: administrationRoutes,
    canActivate: [AdministrationGuard]
  },
  {
    path: 'networkServices',
    component: NetworkServicesComponent,
    children: networkServicesRoutes,
    data: {text: 'network service'}
  },
  {
    path: 'callFlowConfigurations',
    component: CallFlowConfigurationsComponent,
    children: callFlowConfigurationRoutes,
    data: {text: 'call flow configurations'}
  },
  {
    path: 'routing',
    component: RoutingComponent,
    children: routingConfigurationRoutes
  },
  {
    path: 'routingServers',
    component: RoutingServersComponent,
    children: routingServersRoutes,
    data: {text: 'routing servers'}
  },
  {
    path: 'advanced',
    component: AdvancedComponent,
    children: advancedRoutes,
    data: {text: 'advanced'}
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '',
    data: {default: 'administration'}
  }
];

const armRoutes: Routes = [
  {path: 'dashboard', component: DashboardComponent},
  {path: 'network', children: networkRoutes},
  {path: 'routing', children: routingRoutes},
  {path: 'users', children: usersRoutes},
  {path: 'alarms', children: alarmsRoutes},
  {path: 'statistics', children: statisticsRoutes},
  {path: 'calls', children: callsRoutes},
  {path: 'settings', children: settingsRoutes},
  {path: '**', pathMatch: 'full', redirectTo: '', data: {default: 'dashboard'}}
];

const routes: Routes = [
  {path: 'login', component: LoginComponent, data: {autoNavNoHistory: true}, canActivate: [AuthenticationGuard], resolve: {
      azureData: AzureResolver
    }},
  {path: '', component: ArmComponent, children: armRoutes, canActivate: [AuthenticationGuard]},
  {path: '**', redirectTo: '', pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
